import gql from 'graphql-tag'
export default gql`
mutation resetCogUserPassword( $username: String!)  {
  resetCogUserPassword(username: $username)
}

  `